import React, { useState } from "react";
import '../Styles/Admin/AddNewSapak.css';
import AdminHead from "./AdminHead";
import { auth, db } from "../Components/Firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import Loading from "../Components/Loading";
import { useNavigate } from "react-router-dom";

function AddNewSapak() {
  const [formData, setFormData] = useState({
    Email: "",
    IdNumber: "",
    PhoneNumber: "",
    Name: "",
    BName: "",
    CompanyNumber: "",
    Location: "",
    PostalCode: "",
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const translateFirebaseError = (code) => {
    const errorMessages = {
      "auth/invalid-email": "הכתובת אימייל אינה תקינה.",
      "auth/email-already-in-use": "הכתובת אימייל כבר בשימוש.",
      "auth/weak-password": "הסיסמה חלשה מדי.",
      "auth/missing-email": "יש להכניס כתובת אימייל.",
      "auth/missing-password": "יש להכניס סיסמה.",
      "auth/too-many-requests": "יותר מדי בקשות כושלות. נא לנסות מאוחר יותר.",
      "auth/user-disabled": "המשתמש הושבת.",
      "auth/user-not-found": "לא נמצא משתמש עם כתובת האימייל הזאת.",
      "auth/wrong-password": "הסיסמה שגויה.",
    };

    return errorMessages[code] || "אירעה שגיאה לא צפויה. נסה שנית.";
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    const { Email, IdNumber, PhoneNumber, Name, BName, CompanyNumber, Location, PostalCode } = formData;

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, Email, IdNumber);
      const uid = userCredential.user.uid;

      await setDoc(doc(db, "Users", uid), {
        Email,
        IdNumber,
        PhoneNumber,
        Name,
        BName,
        CompanyNumber,
        Location,
        PostalCode,
        Role: "Sapakim",
      });

      setSuccess("הספק נוסף בהצלחה");
      setFormData({
        Email: "",
        IdNumber: "",
        PhoneNumber: "",
        Name: "",
        BName: "",
        CompanyNumber: "",
        Location: "",
        PostalCode: "",
      });

      setTimeout(() => navigate(-1), 1000);
    } catch (err) {
      setError(translateFirebaseError(err.code));
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <AdminHead />

      <div className="add-sapak-container" dir="rtl">
        <h2>הוספת סוכן חדש</h2>

        {loading ? (
          <Loading />
        ) : (
          <form onSubmit={handleSubmit} className="add-sapak-form">
            {error && <p className="error">{error}</p>}
            {success && <p className="success">{success}</p>}

            <input type="email" name="Email" placeholder="אימייל" value={formData.Email} onChange={handleChange} required />
            <input type="text" name="IdNumber" placeholder="תעודת זהות" value={formData.IdNumber} onChange={handleChange} required />
            <input type="text" name="PhoneNumber" placeholder="מספר טלפון" value={formData.PhoneNumber} onChange={handleChange} required />
            <input type="text" name="Name" placeholder="שם מלא" value={formData.Name} onChange={handleChange} required />
            <input type="text" name="BName" placeholder="שם העסק" value={formData.BName} onChange={handleChange} required />
            <input type="text" name="CompanyNumber" placeholder="מספר חברה" value={formData.CompanyNumber} onChange={handleChange} required />
            <input type="text" name="Location" placeholder="כתובת" value={formData.Location} onChange={handleChange} required />
            <input type="text" name="PostalCode" placeholder="מיקוד" value={formData.PostalCode} onChange={handleChange} required />

            <button type="submit">הוסף סוכן</button>
          </form>
        )}
      </div>
    </React.Fragment>
  );
}

export default AddNewSapak;
